import React from "react";
import withSizes from "react-sizes";
import { ResponsiveContainer } from "recharts";

class DynamicChartAreaBase extends React.Component {
  render() {
    return <div style={this.props.mapSizeToStyle(this.props)}>
      <ResponsiveContainer>
        {this.props.children}
      </ResponsiveContainer>
    </div>;
  }
}

const DynamicChartAreaBase2 = withSizes((sizes, ogProps) => ({...sizes, ...ogProps}))(DynamicChartAreaBase);

class DynamicChartArea extends React.Component {
  constructor(props) {
    super(props);
    this.state = { show: null };
  }
  componentDidMount() {
    this.setState({show: true});
  }
  render() {
    return this.state.show && <DynamicChartAreaBase2 {...this.props} />
  }
}

export default DynamicChartArea;
